<template>
  <van-config-provider :theme-vars="themeVars">
    <Frame>
      <template v-slot:header>
        <CustomHeader
          v-if="plateformType === 'webapp'"
          :left-arrow="true"
          left-text="选择访问对象"
          :theme-vars="themeVars"
        />
        <van-search
          v-model="searchName"
          shape="round"
          show-action
          style="--van-search-input-height: 36px"
          placeholder="请输入搜索关键词"
          @search="onSearch"
        >
          <template #action>
            <div @click="onClickButton">搜索</div>
          </template>
        </van-search>
      </template>
      <template v-slot:body>
        <van-list v-if="list && list.length">
          <van-cell
            v-for="item in list"
            :key="item.userIndex"
            :title="item.name"
            :value="item.phone"
            @click="cellClick(item)"
          />
        </van-list>
        <div class="tip" v-else>
          {{ !searchName ? "请输入搜索关键词" : "暂无更多数据" }}
        </div>
      </template>
    </Frame>
  </van-config-provider>
</template>

<script>
import Frame from "@/components/frame.vue"
import CustomHeader from "@/components/customHeader/index.vue"

import { Toast } from "vant"
import { ref, computed } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
export default {
  name: "SearchList",
  components: {
    Frame,
    CustomHeader,
  },
  setup() {
    const store = useStore()
    const router = useRouter()

    const themeVars = ref({
      navBarTextColor: "#333",
      navBarTextSize: "44px",
      searchInputHeight: "30px",
      cellLineHeight: "30px",
    })

    const plateformType = computed(() => store.state.plateformType)
    const schoolCode = computed(() => store.state.schoolCode)

    const searchName = ref("")

    const list = ref([])

    const visitorOpenTeacher = (params) =>
      store.dispatch("visitor/visitorOpenTeacher", params)
    const getTeacherList = async () => {
      let params = {
        schoolCode: schoolCode.value,
        name: searchName.value,
      }
      let r = await visitorOpenTeacher(params)
      if (r.message === "success") {
        list.value = r.data.list || []
      } else {
        Toast.fail(r.message)
      }
    }

    const onSearch = () => {
      getTeacherList()
    }
    const onClickButton = () => {
      getTeacherList()
    }

    const cellClick = (item) => {
      store.commit("visitor/setIntervieweeSelected", item)
      router.go(-1)
    }

    return {
      plateformType,
      themeVars,
      searchName,
      onSearch,
      onClickButton,
      getTeacherList,
      list,
      cellClick,
    }
  },
}
</script>

<style lang="less" scoped>
.tip {
  font-size: 14px;
  color: #999;
  text-align: center;
  margin: 20px auto;
}
.van-list{
  margin-top: 10px;
}
</style>
